import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyCart = () => {
  return (
    <div className="text-center py-16 space-y-6">
      <div className="flex justify-center">
        <div className="w-32 h-32 bg-muted/20 rounded-full flex items-center justify-center">
          <Icon name="ShoppingCart" size={64} className="text-muted-foreground" />
        </div>
      </div>
      <div className="space-y-2">
        <h2 className="text-2xl font-bold command-text">Your cart is empty</h2>
        <p className="text-muted-foreground max-w-md mx-auto">
          Looks like you haven't added any items to your cart yet. Start shopping to fill it up!
        </p>
      </div>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Button variant="default" size="lg" asChild>
          <Link to="/category-pages">
            <Icon name="Grid3X3" size={20} className="mr-2" />
            Browse Categories
          </Link>
        </Button>
        <Button variant="outline" size="lg" asChild>
          <Link to="/homepage">
            <Icon name="Home" size={20} className="mr-2" />
            Back to Home
          </Link>
        </Button>
      </div>
      {/* Featured Categories */}
      <div className="pt-8 border-t border-border">
        <h3 className="text-lg font-semibold mb-4">Popular Categories</h3>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-2xl mx-auto">
          {[
            { name: 'Smartphones', icon: 'Smartphone', path: '/category-pages?category=phones' },
            { name: 'Laptops', icon: 'Laptop', path: '/category-pages?category=laptops' },
            { name: 'Accessories', icon: 'Headphones', path: '/category-pages?category=accessories' },
            { name: 'Chargers', icon: 'Battery', path: '/category-pages?category=chargers' }
          ]?.map((category) => (
            <Link
              key={category?.name}
              to={category?.path}
              className="neural-nav-item p-4 rounded-lg border border-border hover:border-primary/30 transition-all duration-300 group"
            >
              <div className="flex flex-col items-center space-y-2">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                  <Icon name={category?.icon} size={24} className="text-primary" />
                </div>
                <span className="text-sm font-medium text-center">{category?.name}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmptyCart;